// removed by extract-text-webpack-plugin
module.exports = {"container":"_1h1fztc5lW5ZHjDNUjht_R","App":"_1o-FpbQrR11SDFN-G7O4U3","App-logo":"_3JCPttIlaO1n9gbarj-AYQ","App-logo-spin":"RvI1Jd7nZvV5oabR4RbAY","App-header":"_3iH8LjVH-8aINDFVrlCaZ1","App-title":"EIoWqrQKD2eTf7hUlljY9","App-intro":"_1OgPcCismP_tc5RWUvuMBa","noScroll":"uXBBHjjqF8XWMgNPEPRSm"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 87
// module chunks = 0